import { call, put, takeLatest } from 'redux-saga/effects';
import { systemService } from './system.service';
import {
    GET_CREDENTIAL_GLOBAL_SUCCESS,
    CREATE_CREDENTIAL_GLOBAL,
    GET_CREDENTIAL_GLOBAL,
    EDIT_CREDENTIAL_BY_ID_GLOBAL,
    DELETE_CREDENTIAL_BY_ID_GLOBAL,
    CREATE_SERVICE_GLOBAL,
    GET_SERVICES_SUCCESS,
    GET_SERVICES,
    EDIT_SERVICE_BY_ID_GLOBAL,
    DELETE_SERVICE_BY_ID_GLOBAL,
    GET_DEPARTMENTS,
    GET_DEPARTMENTS_SUCCESS,
    CREATE_DEPARTMENT_GLOBAL,
    EDIT_DEPARTMENT_BY_ID_GLOBAL,
    DELETE_DEPARTMENT_BY_ID_GLOBAL,
    CREATE_JOB_GLOBAL,
    GET_JOBS,
    EDIT_JOB_BY_ID_GLOBAL,
    DELETE_JOB_BY_ID_GLOBAL,
    GET_JOBS_SUCCESS,
    CREATE_PLACE_GLOBAL,
    GET_PLACES,
    EDIT_PLACE_BY_ID_GLOBAL,
    DELETE_PLACE_BY_ID_GLOBAL,
    GET_PLACES_SUCCESS,
    CREATE_COVERED_CREDENTIAL,
    SELECTED_CREDENTIAL,
    EDIT_COVERED_CREDENTIAL,
    CREATE_COMPANY,
    GET_COMPANY,
    EDIT_COMPANY,
    DELETE_COMPANY,
    GET_COMPANY_SUCCESS,
    GET_CONNECT_CALENDARS,
    GET_CONNECT_CALENDARS_SUCCESS,
    DISCONNECT_CALENDAR,
    CHANGE_CALENDAR_STATUS,
    STRIPE_SETTINGS,
    CREATE_BANK,
    GET_BANKS,
    EDIT_BANK,
    DELETE_BANK,
    GET_BANKS_SUCCESS,
    CHANGE_AI_INTEGRATION,
    GET_SYSTEM_INTEGRATIONS,
    CONNECT_INTEGRATION,
    DISCONNECT_INTEGRATION,
    EDIT_INTEGRATION_CONNECTION,
    CAN_USE_INTEGRATION,
    DELETE_INTEGRATION,
    GET_SYSTEM_INTEGRATIONS_SUCCESS,
    CAN_USE_INTEGRATION_SUCCESS,
    CONNECT_ZOOM,
    EDIT_ZOOM_STATUS,
    CONNECTION_ZOOM_TO_THERAPY,
    CREATE_ZOOM_MEETING,
    DELETE_ZOOM_MEETING,
    GET_ZOOM_USERS,
    GET_ZOOM_USERS_SUCCESS,
    GET_COMPANIES,
    GET_COMPANIES_SUCCESS,
    CONNECT_GOOGLE_MEET,
    CONNECTION_GOOGLE_MEET_TO_THERAPY,
    EDIT_GOOGLE_MEET_STATUS,
    GET_TELEHEALTH_STATUS,
    GET_TELEHEALTH_STATUS_SUCCESS,
    GET_SUPERVISION_CONFIG,
    GET_SUPERVISION_CONFIG_SUCCESS,
    UPDATE_SUPERVISION_CONFIG,
    UPDATE_CLINICAL_SETTINGS,
    CLINICAL_SETTINGS_SESSION_GOALS_SAVED,
    CLINICAL_SETTINGS_GOAL_ORDER_SAVED,
    GET_ELIGIBILITY_AUTO_CHECK_CONFIG,
    GET_ELIGIBILITY_AUTO_CHECK_CONFIG_SUCCESS,
    UPDATE_ELIGIBILITY_AUTO_CHECK_CONFIG,
    RUN_BATCH_ELIGIBILITY_CHECK,
    GET_MEMBERS_PORTAL_CONFIG,
    GET_MEMBERS_PORTAL_CONFIG_SUCCESS,
    UPDATE_MEMBERS_PORTAL_CONFIG,
} from './system.type';
import { httpRequestsOnLoadActions } from '../http_requests_on_load';
import { httpRequestsOnSuccessActions } from '../http_requests_on_success';
import { httpRequestsOnErrorsActions } from '../http_requests_on_errors';
import { toast } from 'react-toastify';
import { NotError } from '../../components';
import React from 'react';
import { GET_APPOINTMENT_BY_ID_SUCCESS } from '../appointment/appointment.type';
import { GET_MY_PROFILE } from '../auth/auth.types';
import { getAppointmentWithSessionIfAllowed } from '../appointment/appointment.saga';

/** Service Type */

function* createServiceGlobal(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        yield call(systemService.createServiceGlobalService, action.payload.body);
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

function* getServices(action) {
    if (action?.payload?.load !== 'noLoad') {
        yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    }
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    try {
        const pageConfig = action.payload?.data;
        const res = yield call(systemService.getServicesService, pageConfig);
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put({
            type: GET_SERVICES_SUCCESS,
            payload: { services: res.data },
        });
    } catch (err) {
        yield put({
            type: GET_SERVICES_SUCCESS,
            payload: { services: { services: [], count: 0 } },
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        if (err?.data?.message === 'Internal server error') {
            yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
        }
    }
}

function* editServiceByIdGlobal(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        yield call(systemService.editServiceByIdGlobalService, action.payload.id, action.payload.body);
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

function* deleteServiceByIdGlobal(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        yield call(systemService.deleteServiceByIdService, action.payload.id);
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

/** End */

/** Credentials */

function* createCredentialGlobal(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        yield call(systemService.createCredentialGlobalService, action.payload.body);
        yield put({
            type: GET_CREDENTIAL_GLOBAL,
            payload: { load: 'noLoad' },
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

function* createCoveredCredential(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        const res = yield call(systemService.createCoveredCredentialService, action?.payload?.id, action?.payload?.body);
        yield put({
            type: SELECTED_CREDENTIAL,
            payload: res?.data,
        });
        yield put({
            type: GET_CREDENTIAL_GLOBAL,
            payload: { load: 'noLoad' },
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

function* editCoveredCredential(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        const res = yield call(systemService.editCoveredCredentialService, action?.payload);
        yield put({
            type: SELECTED_CREDENTIAL,
            payload: res?.data,
        });
        yield put({
            type: GET_CREDENTIAL_GLOBAL,
            payload: { load: 'noLoad' },
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

function* getCredentialGlobal(action) {
    if (action?.payload?.load !== 'noLoad') {
        yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    }
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    try {
        const res = yield call(systemService.getCredentialGlobalService, action?.payload);
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put({
            type: GET_CREDENTIAL_GLOBAL_SUCCESS,
            payload: res.data,
        });
    } catch (err) {
        yield put({
            type: GET_CREDENTIAL_GLOBAL_SUCCESS,
            payload: '',
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        if (err?.data?.message === 'Internal server error') {
            yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
        }
    }
}

function* editCredentialById(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        const res = yield call(systemService.editCredentialByIdGlobalService, action.payload.id, action.payload.body);
        yield put({
            type: SELECTED_CREDENTIAL,
            payload: res?.data,
        });
        yield put({
            type: GET_CREDENTIAL_GLOBAL,
            payload: { load: 'noLoad' },
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

function* deleteCredentialByIdGlobal(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        yield call(systemService.deleteCredentialByIdService, action.payload.id);
        yield put({
            type: GET_CREDENTIAL_GLOBAL,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

/** End */

/** Departments */

function* createDepartmentGlobal(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        yield call(systemService.createDepartmentGlobalService, action.payload.body);
        yield put({
            type: GET_DEPARTMENTS,
            payload: { load: 'noLoad' },
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

function* getDepartments(action) {
    if (action?.payload?.load !== 'noLoad') {
        yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    }
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    try {
        const res = yield call(systemService.getDepartmentsService);
        yield put({
            type: GET_DEPARTMENTS_SUCCESS,
            payload: res.data.reverse(),
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    } catch (err) {
        yield put({
            type: GET_DEPARTMENTS_SUCCESS,
            payload: '',
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        if (err?.data?.message === 'Internal server error') {
            yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
        }
    }
}

function* editDepartmentByIdGlobal(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        yield call(systemService.editDepartmentByIdGlobalService, action.payload.id, action.payload.body);
        yield put({
            type: GET_DEPARTMENTS,
            payload: { load: 'noLoad' },
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

function* deleteDepartmentByIdGlobal(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        yield call(systemService.deleteDepartmentByIdService, action.payload.id);
        yield put({
            type: GET_DEPARTMENTS,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

/** End */

/** Job */

function* createJobGlobal(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        yield call(systemService.createJobGlobalService, action?.payload?.body);
        yield put({
            type: GET_JOBS,
            payload: { load: 'noLoad' },
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

function* getJobs(action) {
    if (action?.payload?.load !== 'noLoad') {
        yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    }
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    try {
        const res = yield call(systemService.getJobsService);
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put({
            type: GET_JOBS_SUCCESS,
            payload: res.data.reverse(),
        });
    } catch (err) {
        yield put({
            type: GET_JOBS_SUCCESS,
            payload: '',
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        if (err?.data?.message === 'Internal server error') {
            yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
        }
    }
}

function* editJobByIdGlobal(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        yield call(systemService.editJobByIdGlobalService, action.payload.id, action.payload.body);
        yield put({
            type: GET_JOBS,
            payload: { load: 'noLoad' },
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

function* deleteJobByIdGlobal(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        yield call(systemService.deleteJobByIdService, action.payload.id);
        yield put({
            type: GET_JOBS,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

/** End */

/** Places */

function* createPlaceGlobal(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        yield call(systemService.createPlaceGlobalService, action.payload.body);
        yield put({
            type: GET_PLACES,
            payload: { load: 'noLoad' },
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

function* getPlaces(action) {
    if (action?.payload?.load !== 'noLoad') {
        yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    }
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    try {
        const res = yield call(systemService.getPlacesService);
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put({
            type: GET_PLACES_SUCCESS,
            payload: res.data.reverse(),
        });
    } catch (err) {
        yield put({
            type: GET_PLACES_SUCCESS,
            payload: '',
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        if (err?.data?.message === 'Internal server error') {
            yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
        }
    }
}

function* editPlaceByIdGlobal(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        yield call(systemService.editPlaceByIdGlobalService, action.payload.id, action.payload.body);
        yield put({
            type: GET_PLACES,
            payload: { load: 'noLoad' },
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

function* deletePlaceByIdGlobal(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        yield call(systemService.deletePlaceByIdService, action.payload.id);
        yield put({
            type: GET_PLACES,
            payload: { load: 'noLoad' },
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

/** End */

/** Companies */

function* getCompanies(action) {
    if (action?.payload?.load !== 'noLoad') {
        yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    }
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    try {
        const res = yield call(systemService.getCompaniesService);
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put({
            type: GET_COMPANIES_SUCCESS,
            payload: res.data,
        });
    } catch (err) {
        yield put({
            type: GET_COMPANIES_SUCCESS,
            payload: [],
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        if (err?.data?.message === 'Internal server error') {
            yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
        }
    }
}

/** End */

/** Company */

function* createCompany(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        yield call(systemService.createCompanyService, action?.payload?.params);
        yield put({
            type: GET_COMPANY,
            payload: { load: 'noLoad' },
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

function* getCompany(action) {
    if (action?.payload?.load !== 'noLoad') {
        yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    }
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    try {
        const res = yield call(systemService.getCompanyService);
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put({
            type: GET_COMPANY_SUCCESS,
            payload: res.data,
        });
    } catch (err) {
        yield put({
            type: GET_COMPANY_SUCCESS,
            payload: null,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        if (err?.data?.message === 'Internal server error') {
            yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
        }
    }
}

function* editCompany(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        let body = action?.payload?.params;
        if (action?.payload?.mergeLatest) {
            const latest = yield call(systemService.getCompanyService);
            body = { ...latest?.data, ...body };
        }
        yield call(systemService.editCompanyService, action?.payload?.id, body);
        yield put({
            type: GET_COMPANY,
            payload: { load: 'noLoad' },
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

function* deleteCompany(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        yield call(systemService.deleteCompanyService, action?.payload?.id);
        yield put({
            type: GET_COMPANY,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

/** End */

/** Calendars */
function* getConnectCalendars(action) {
    if (action?.payload?.load !== 'noLoad') {
        yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    }
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        const res = yield call(systemService.getConnectCalendarsService);
        yield put({
            type: GET_CONNECT_CALENDARS_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

function* disconnectCalendar(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        yield call(systemService.disconnectCalendarService, action?.payload);
        yield put({
            type: GET_CONNECT_CALENDARS,
            payload: { load: 'noLoad' },
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

function* changeCalendarStatus(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        const res = yield call(systemService.changeCalendarStatusService, action?.payload);
        yield put({
            type: GET_CONNECT_CALENDARS_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

/** End */

/** Stripe */
function* stripeSettings(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    try {
        yield call(systemService.stripeSettingsService, action?.payload);
        const res = yield call(systemService.getCompanyService);
        yield put({
            type: GET_COMPANY_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    } catch (err) {
        yield put(httpRequestsOnErrorsActions.appendError(action?.type, err?.data?.message));
        yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        toast(<NotError type={'error'} errMessage={err?.data?.message} />);
    }
}

/** End */

/** Bank */

function* createBank(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        yield call(systemService.createBankService, action.payload.body);
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

function* getBanks(action) {
    if (action?.payload?.load !== 'noLoad') {
        yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    }
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    try {
        const res = yield call(systemService.getBanksService, action.payload?.data);
        yield put({
            type: GET_BANKS_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

function* editBank(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        yield call(systemService.editBankService, action.payload.id, action.payload.body);
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

function* deleteBank(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        yield call(systemService.deleteBankService, action.payload.id);
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

/** Ai Integration */
function* changeAiIntegration(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    try {
        yield call(systemService.changeAiIntegrationService, action?.payload);
        // const text = action?.payload?.isActive ? 'AI Voice Transcription & Summarization has been enabled.' : 'AI Voice Transcription & Summarization has been disabled.';
        toast(<NotError errMessage={'Organization Integration settings was updated'} />);
        const res = yield call(systemService.getCompanyService);
        yield put({
            type: GET_COMPANY_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    } catch (err) {
        yield put(httpRequestsOnErrorsActions.appendError(action?.type, err?.data?.message));
        yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        toast(<NotError type={'error'} errMessage={err?.data?.message} />);
    }
}

/** End */

/** Integrations */

function* getIntegrations(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    try {
        const res = yield call(systemService.getIntegrationsService);
        yield put({
            type: GET_SYSTEM_INTEGRATIONS_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    }
}

function* connectIntegration(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    try {
        yield call(systemService.connectIntegrationService, action?.payload);

        const res = yield call(systemService.getIntegrationsService);
        yield put({
            type: GET_SYSTEM_INTEGRATIONS_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    } catch (err) {
        toast(<NotError type={'error'} errMessage={err?.data?.message} />);
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
        yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    }
}

function* disconnectIntegration(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        yield call(systemService.disconnectIntegrationService, action?.payload?.isActive, action?.payload?.type);
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));

        const res = yield call(systemService.getIntegrationsService);
        yield put({
            type: GET_SYSTEM_INTEGRATIONS_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    } catch (err) {
        yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    }
}

function* editIntegration(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        yield call(systemService.editIntegrationService, action?.payload);

        const res = yield call(systemService.getIntegrationsService);
        yield put({
            type: GET_SYSTEM_INTEGRATIONS_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    } catch (err) {
        yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    }
}

function* canUseIntegration(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        const res = yield call(systemService.canUseIntegrationService);
        yield put({
            type: CAN_USE_INTEGRATION_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    } catch (err) {
        yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    }
}

function* deleteIntegration(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        yield call(systemService.deleteIntegrationService);

        const res = yield call(systemService.getIntegrationsService);
        yield put({
            type: GET_SYSTEM_INTEGRATIONS_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    } catch (err) {
        yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    }
}

/** End */

/** oom */
function* connectZoom(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        // yield call(systemService.connectZoomService, action?.payload)

        const authUrl = yield call(systemService.getZoomAuthUrlZoomService);
        window.location.replace(authUrl?.data);
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    } catch (err) {
        yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    }
}

function* connectZoomToTherapy(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        yield call(systemService.connectZoomToTherapyService, action?.payload);
        const res = yield call(systemService.getTelehealthStatusService);
        yield put({
            type: GET_TELEHEALTH_STATUS_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    } catch (err) {
        yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    }
}

function* editZoomStatus(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        yield call(systemService.editZoomStatusService);

        const res = yield call(systemService.getTelehealthStatusService);
        yield put({
            type: GET_TELEHEALTH_STATUS_SUCCESS,
            payload: res.data,
        });

        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    } catch (err) {
        yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    }
}


function* createZoomMeeting(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        yield call(systemService.createZoomMeetingService, action?.payload?.body);

        const apptId = action?.payload?.appt?.id;
        const data = yield call(getAppointmentWithSessionIfAllowed, apptId);
        yield put({
            type: GET_APPOINTMENT_BY_ID_SUCCESS,
            payload: data,
        });

        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    } catch (err) {
        toast(<NotError type={'error'} errMessage={err?.data?.message} />);
        yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    }
}
function* deleteZoomMeeting(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        yield call(systemService.deleteZoomMeetingService, action?.payload?.apptId);

        const data = yield call(getAppointmentWithSessionIfAllowed, action?.payload?.apptId);
        yield put({
            type: GET_APPOINTMENT_BY_ID_SUCCESS,
            payload: data,
        });

        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    } catch (err) {
        const data = yield call(getAppointmentWithSessionIfAllowed, action?.payload?.apptId);
        yield put({
            type: GET_APPOINTMENT_BY_ID_SUCCESS,
            payload: data,
        });
        toast(<NotError type={'error'} errMessage={err?.data?.message} />);
        yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    }
}

function* getZoomUsers(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    try {
        const res = yield call(systemService.getZoomUsersService);
        yield put({
            type: GET_ZOOM_USERS_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    } catch (err) {
        yield put({
            type: GET_ZOOM_USERS_SUCCESS,
            payload: [],
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

/** End */

/** Google Meet */
function* connectGoogleMeet(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        const authUrl = yield call(systemService.getGoogleMeetAuthUrlService);
        window.location.replace(authUrl?.data);

        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    } catch (err) {
        yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    }
}

function* connectGoogleMeetToTherapy(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        yield call(systemService.connectGoogleMeetToTherapyService, action?.payload);

        const res = yield call(systemService.getTelehealthStatusService);
        yield put({
            type: GET_TELEHEALTH_STATUS_SUCCESS,
            payload: res.data,
        });

        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    } catch (err) {
        yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    }
}

function* editGoogleMeetStatus(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        yield call(systemService.editGoogleMeetStatusService);

        const res = yield call(systemService.getTelehealthStatusService);
        yield put({
            type: GET_TELEHEALTH_STATUS_SUCCESS,
            payload: res.data,
        });

        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    } catch (err) {
        yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    }
}



/** End */

/** Telehealth */
function* getTelehealthStatus(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    try {
        const res = yield call(systemService.getTelehealthStatusService);
        yield put({
            type: GET_TELEHEALTH_STATUS_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    }
}
/** End */

/** Supervision Config */

function* getSupervisionConfig(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    try {
        const res = yield call(systemService.getSupervisionConfigService);
        yield put({
            type: GET_SUPERVISION_CONFIG_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    }
}

function* updateSupervisionConfig(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    try {
        yield call(systemService.updateSupervisionConfigService, action?.payload);
        const res = yield call(systemService.getSupervisionConfigService);
        yield put({
            type: GET_SUPERVISION_CONFIG_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
        toast(<NotError type={'error'} errMessage={err?.data?.message} />);
    }
}

/** End */

/** Clinical Settings */

function* updateClinicalSettings(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    try {
        // PUT returns the whole CompanyDTO — refresh the company the settings screen already reads.
        const res = yield call(systemService.updateClinicalSettingsService, action?.payload);
        yield put({
            type: GET_COMPANY_SUCCESS,
            payload: res.data,
        });
        // The session screens read this flag off `userInfo`, which comes from
        // GET /staff/myProfile — without this refetch the toggle would not take
        // effect there until the next login.
        yield put({ type: GET_MY_PROFILE });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
        // One endpoint saves every clinical setting; a per-setting key gives each save its own success toast.
        if (action?.payload?.includeAllActiveGoalsInSessions !== undefined) {
            yield put(httpRequestsOnSuccessActions.appendSuccess(CLINICAL_SETTINGS_SESSION_GOALS_SAVED));
        }
        if (action?.payload?.goalSortType !== undefined) {
            yield put(httpRequestsOnSuccessActions.appendSuccess(CLINICAL_SETTINGS_GOAL_ORDER_SAVED));
        }
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
        toast(<NotError type={'error'} errMessage={err?.data?.message} />);
    }
}

/** End */

/** Eligibility Auto-Check Config */

function* getEligibilityAutoCheckConfig(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    try {
        const res = yield call(systemService.getEligibilityAutoCheckConfigService);
        yield put({
            type: GET_ELIGIBILITY_AUTO_CHECK_CONFIG_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    }
}

function* updateEligibilityAutoCheckConfig(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    try {
        yield call(systemService.updateEligibilityAutoCheckConfigService, action?.payload);
        const res = yield call(systemService.getEligibilityAutoCheckConfigService);
        yield put({
            type: GET_ELIGIBILITY_AUTO_CHECK_CONFIG_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
        toast(<NotError type={'error'} errMessage={err?.data?.message} />);
    }
}

function* getMembersPortalConfig(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    try {
        const res = yield call(systemService.getMembersPortalConfigService);
        yield put({
            type: GET_MEMBERS_PORTAL_CONFIG_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    }
}

function* updateMembersPortalConfig(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    try {
        const res = yield call(systemService.updateMembersPortalConfigService, action?.payload);
        yield put({
            type: GET_MEMBERS_PORTAL_CONFIG_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
        toast(<NotError type={'error'} errMessage={err?.data?.message} />);
    }
}

function* runBatchEligibilityCheck(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    try {
        yield call(systemService.runBatchEligibilityCheckService);
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
        toast(<NotError type={'success'} errMessage={'Batch eligibility check submitted successfully. Results will be processed in the background.'} />);
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
        toast(<NotError type={'error'} errMessage={err?.data?.message} />);
    }
}

/** End */

export const watchSystem = function* watchSystemSaga() {
    /** Service Type */
    yield takeLatest(CREATE_SERVICE_GLOBAL, createServiceGlobal);
    yield takeLatest(GET_SERVICES, getServices);
    yield takeLatest(EDIT_SERVICE_BY_ID_GLOBAL, editServiceByIdGlobal);
    yield takeLatest(DELETE_SERVICE_BY_ID_GLOBAL, deleteServiceByIdGlobal);
    /** End */

    /** Credentials */
    yield takeLatest(CREATE_CREDENTIAL_GLOBAL, createCredentialGlobal);
    yield takeLatest(CREATE_COVERED_CREDENTIAL, createCoveredCredential);
    yield takeLatest(EDIT_COVERED_CREDENTIAL, editCoveredCredential);
    yield takeLatest(GET_CREDENTIAL_GLOBAL, getCredentialGlobal);
    yield takeLatest(EDIT_CREDENTIAL_BY_ID_GLOBAL, editCredentialById);
    yield takeLatest(DELETE_CREDENTIAL_BY_ID_GLOBAL, deleteCredentialByIdGlobal);
    /** End */

    /** Department */
    yield takeLatest(CREATE_DEPARTMENT_GLOBAL, createDepartmentGlobal);
    yield takeLatest(GET_DEPARTMENTS, getDepartments);
    yield takeLatest(EDIT_DEPARTMENT_BY_ID_GLOBAL, editDepartmentByIdGlobal);
    yield takeLatest(DELETE_DEPARTMENT_BY_ID_GLOBAL, deleteDepartmentByIdGlobal);
    /** End */

    /** Job */
    yield takeLatest(CREATE_JOB_GLOBAL, createJobGlobal);
    yield takeLatest(GET_JOBS, getJobs);
    yield takeLatest(EDIT_JOB_BY_ID_GLOBAL, editJobByIdGlobal);
    yield takeLatest(DELETE_JOB_BY_ID_GLOBAL, deleteJobByIdGlobal);
    /** End */

    /** Places */
    yield takeLatest(CREATE_PLACE_GLOBAL, createPlaceGlobal);
    yield takeLatest(GET_PLACES, getPlaces);
    yield takeLatest(EDIT_PLACE_BY_ID_GLOBAL, editPlaceByIdGlobal);
    yield takeLatest(DELETE_PLACE_BY_ID_GLOBAL, deletePlaceByIdGlobal);
    /** End */

    /** Companies */
    yield takeLatest(GET_COMPANIES, getCompanies);
    /** End */

    /** Company */
    yield takeLatest(CREATE_COMPANY, createCompany);
    yield takeLatest(GET_COMPANY, getCompany);
    yield takeLatest(EDIT_COMPANY, editCompany);
    yield takeLatest(DELETE_COMPANY, deleteCompany);
    /** End */

    /** Calendars */
    yield takeLatest(GET_CONNECT_CALENDARS, getConnectCalendars);
    yield takeLatest(DISCONNECT_CALENDAR, disconnectCalendar);
    yield takeLatest(CHANGE_CALENDAR_STATUS, changeCalendarStatus);
    /** End */

    /** Stripe */
    yield takeLatest(STRIPE_SETTINGS, stripeSettings);
    /** End */

    /** Bank */
    yield takeLatest(CREATE_BANK, createBank);
    yield takeLatest(GET_BANKS, getBanks);
    yield takeLatest(EDIT_BANK, editBank);
    yield takeLatest(DELETE_BANK, deleteBank);

    /** Ai Integration */
    yield takeLatest(CHANGE_AI_INTEGRATION, changeAiIntegration);
    /** End */

    /** Integrations */
    yield takeLatest(GET_SYSTEM_INTEGRATIONS, getIntegrations);
    yield takeLatest(CONNECT_INTEGRATION, connectIntegration);
    yield takeLatest(DISCONNECT_INTEGRATION, disconnectIntegration);
    yield takeLatest(EDIT_INTEGRATION_CONNECTION, editIntegration);
    yield takeLatest(CAN_USE_INTEGRATION, canUseIntegration);
    yield takeLatest(DELETE_INTEGRATION, deleteIntegration);
    /** End */

    /** Zoom */
    yield takeLatest(CONNECT_ZOOM, connectZoom);
    yield takeLatest(CONNECTION_ZOOM_TO_THERAPY, connectZoomToTherapy);
    yield takeLatest(EDIT_ZOOM_STATUS, editZoomStatus);
    yield takeLatest(CREATE_ZOOM_MEETING, createZoomMeeting);
    yield takeLatest(DELETE_ZOOM_MEETING, deleteZoomMeeting);
    yield takeLatest(GET_ZOOM_USERS, getZoomUsers);
    /** End */

    /** Google Meet */
    yield takeLatest(CONNECT_GOOGLE_MEET, connectGoogleMeet);
    yield takeLatest(CONNECTION_GOOGLE_MEET_TO_THERAPY, connectGoogleMeetToTherapy);
    yield takeLatest(EDIT_GOOGLE_MEET_STATUS, editGoogleMeetStatus);
    /** End */

    /** Telehealth */
    yield takeLatest(GET_TELEHEALTH_STATUS, getTelehealthStatus);
    /** End */

    /** Supervision Config */
    yield takeLatest(GET_SUPERVISION_CONFIG, getSupervisionConfig);
    yield takeLatest(UPDATE_SUPERVISION_CONFIG, updateSupervisionConfig);
    yield takeLatest(UPDATE_CLINICAL_SETTINGS, updateClinicalSettings);
    /** End */

    /** Eligibility Auto-Check Config */
    yield takeLatest(GET_ELIGIBILITY_AUTO_CHECK_CONFIG, getEligibilityAutoCheckConfig);
    yield takeLatest(UPDATE_ELIGIBILITY_AUTO_CHECK_CONFIG, updateEligibilityAutoCheckConfig);
    yield takeLatest(RUN_BATCH_ELIGIBILITY_CHECK, runBatchEligibilityCheck);
    yield takeLatest(GET_MEMBERS_PORTAL_CONFIG, getMembersPortalConfig);
    yield takeLatest(UPDATE_MEMBERS_PORTAL_CONFIG, updateMembersPortalConfig);
    /** End */
};
